<template>
  <div>
    <v-container fluid class="px-0">
      <v-card outlined elevation="3">
        <v-card-text>
          <v-data-table
            class="black--text"
            :headers="headers"
            :search="search"
            :items="dataMaterial"
            :loading="loading"
            dense
          >
            <template v-slot:top>
              <v-toolbar flat dense class="mb-3">
                <v-row>
                  <v-col md="8">
                    <v-text-field
                      outlined
                      dense
                      v-model="search"
                      append-icon="mdi-magnify"
                      autocomple="off"
                      placeholder="Search..."
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="modify" md="4" align="right">
                    <v-btn
                      color="#61B15A"
                      class="text-subtitle-2 white--text"
                      style="text-transform: unset !important"
                      @click="checkType(0)"
                    >
                      <v-icon left>mdi-plus-circle</v-icon>
                      Tambah Material
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>

            <template v-slot:item.is_activated="{ item }">
              <v-chip
                small
                class="font-weight-bold error--text"
                v-if="item.is_activated === 0"
              >
                Disabled
              </v-chip>
              <v-chip small class="font-weight-bold primary--text" v-else>
                Active
              </v-chip>
            </template>

            <template v-if="modify" v-slot:item.actions="{ item }">
              <v-btn
                color="#FFA900"
                small
                class="text-caption white--text mr-2"
                style="text-transform: unset !important"
                @click.prevent="checkType(item.id)"
              >
                Edit
              </v-btn>
              <v-btn
                color="#EB4646"
                small
                class="text-caption white--text mr-2"
                style="text-transform: unset !important"
                @click.prevent="hapus(item)"
              >
                <span v-if="item.is_activated === 0">Active</span>
                <span v-else>Disabled</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <olah-data
      :olahDataDialog="olahDataDialog"
      :olahDataTitle="olahDataTitle"
      :olahDataBtn="olahDataBtn"
      :olahData="olahData"
      :typeAction="typeAction"
      :typeBox="typeBox"
      :materialCode="materialCode"
      @closeOlahDataDialog="closeOlahDataDialog"
      @reloadData="reloadData"
    />

    <v-dialog v-model="progress" width="500">
      <v-card>
        <v-card-text class="pt-5">
          <v-progress-linear indeterminate color="#FFA900"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="popDialog" width="450">
      <v-card color="white" rounded>
        <v-card-title class="justify-center text-h6 black--text">
          {{ popTitle }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="light-green darken-1"
            class="white--text"
            @click="closePopDialog"
            >Tutup</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" persistent max-width="500px">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold black--text">
          Ubah status Material
        </v-card-title>
        <v-card-subtitle class="mt-1 text-subtitle-2 black--text">
          Status Material akan dirubah. Yakin melanjutkan proses ini?
        </v-card-subtitle>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#61B15A"
            style="text-transform: unset !important"
            @click="closeDelete"
          >
            Batal
          </v-btn>
          <v-btn
            color="#EB4646"
            class="white--text"
            style="text-transform: unset !important"
            @click="deleteItemConfirm"
          >
            Proses
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import olahData from "./olahData.vue";

export default {
  components: { olahData },
  props: { modify: Boolean },
  data: () => ({
    search: "",
    loading: false,
    headers: [
      {
        text: "Kode Material",
        class: "text-subtitle-2 font-weight-bold black--text",
        value: "kode",
      },
      {
        text: "Description",
        class: "text-subtitle-2 font-weight-bold black--text",
        value: "desc",
      },
      {
        text: "Satuan",
        class: "text-subtitle-2 font-weight-bold black--text",
        value: "satuan",
      },
      {
        text: "Status",
        class: "text-subtitle-2 font-weight-bold black--text",
        value: "is_activated",
      },
      {
        text: "Material Code",
        class: "text-subtitle-2 font-weight-bold black--text",
        value: "mat_code",
      },
      {
        text: "Action",
        class: "text-subtitle-2 font-weight-bold black--text",
        value: "actions",
      },
    ],
    dataMaterial: [],
    typeBox: [],
    materialCode: [],
    typeAction: "",
    olahDataTitle: "",
    olahDataBtn: "",
    olahDataDialog: false,
    olahData: {},
    popDialog: false,
    popTitle: "",
    deleteData: {},
    dialogDelete: false,
    progress: false,
  }),

  methods: {
    ...mapActions({
      refreshAction: "auth/refresh",
    }),

    getData() {
      this.loading = true;
      axios
        .get("v1/admin/material/list?limit=100")
        .then((response) => {
          this.loading = false;
          this.dataMaterial = response.data.data;
          this.getTypeBox();
          this.getMaterialCode();
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              this.refreshAction(localStorage.getItem("refresh"));
              this.getData();
            }
            console.clear();
          }
        });
    },
    getDataById(id) {
      axios
        .get("v1/admin/material?id=" + id)
        .then((response) => {
          this.olahData = response.data.data;
          this.typeAction = "edit";
          this.olahDataTitle = "Edit Material";
          this.olahDataBtn = "Edit & Simpan";
          this.progress = false;
          this.olahDataDialog = true;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              this.refreshAction(localStorage.getItem("refresh"));
              this.getData();
            }
            console.clear();
          }
        });
    },
    getTypeBox() {
      axios.get("v1/admin/box_type/list").then((response) => {
        this.typeBox = response.data.data;
      });
    },
     getMaterialCode() {
     axios.get("v1/user/material_code/list?limit=100").then((response) => {
       
         this.materialCode = response.data.data;
       
      });
      },
    checkType(value) {
      if (value === 0) {
        this.typeAction = "new";
        this.olahDataTitle = "Tambah Material";
        this.olahDataBtn = "Tambahkan";
        this.olahDataDialog = true;
      } else {
        this.progress = true;
        this.getDataById(value);
      }
    },
    hapus(value) {
      this.deleteData = value;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.loading = true;
      this.dataMaterial = [];
      this.typeAction = "edit";
      const data = this.deleteData;
      if (this.deleteData.is_activated === 0) {
        data.is_activated = 1;
      } else {
        data.is_activated = 0;
      }
      const dataSend = JSON.stringify(data);
      axios
        .put("v1/admin/material", dataSend, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            this.reloadData();
            this.closeDelete();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            console(error.response);
          }
        });
    },
    closeDelete() {
      this.dataMaterial = [];
      this.getData();
      this.dialogDelete = false;
    },
    reloadData() {
      if (this.typeAction === "edit") {
        this.popTitle = "Data Handheld berhasil diperbaharui";
        this.popDialog = true;
      } else if (this.typeAction === "new") {
        this.popTitle = "Data Handheld berhasil ditambahkan";
        this.popDialog = true;
      }
    },
    closeOlahDataDialog() {
      this.olahData = {};
      this.dataMaterial = [];
      this.getData();
      this.olahDataDialog = false;
    },
    closePopDialog() {
      this.popTitle = "";
      this.popDialog = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>